import { render, staticRenderFns } from "./BankAccounts.vue?vue&type=template&id=42e08b30&scoped=true"
import script from "./BankAccounts.vue?vue&type=script&lang=js"
export * from "./BankAccounts.vue?vue&type=script&lang=js"
import style0 from "./BankAccounts.vue?vue&type=style&index=0&id=42e08b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e08b30",
  null
  
)

export default component.exports